import type { BookingSettings, BookingSettingsInput, BookingThemeData } from 'owa-graph-schema';
import mapToBookingThemeDataInput from './mapToBookingThemeDataInput';

const mapToBookingSettingsInput = (settings: BookingSettings): BookingSettingsInput => {
    const {
        otpVerificationSetting,
        publishingUrl,
        themeData,
        c2RevampedEnabled,
        authType,
        friendlyUrl,
        isLogoHidden,
        isConsentNeeded,
        consentText,
        customColorScheme,
        isSearchEngineIndexabilityDisabled,
        showTimeSlotsInBusinessTimeZone,
        emailVerificationMethod,
        sendMeetingInviteToCustomer,
        onDemandServicesSetting,
    } = settings;

    const modifiedSettings: BookingSettingsInput = {
        otpVerificationSetting,
        publishingUrl,
        c2RevampedEnabled,
        authType,
        friendlyUrl,
        isLogoHidden,
        isConsentNeeded,
        consentText,
        customColorScheme,
        isSearchEngineIndexabilityDisabled,
        showTimeSlotsInBusinessTimeZone,
        themeData: mapToBookingThemeDataInput(themeData as BookingThemeData),
        emailVerificationMethod,
        sendMeetingInviteToCustomer,
        onDemandServicesSetting,
    };
    return modifiedSettings;
};

export default mapToBookingSettingsInput;
